<section>
  <footer class="sticky-footer bg-white">
    <div class="my-auto mx-3">
      <div class="copyright d-flex justify-content-between my-auto flex-column-footer">
        <div class="d-flex flex-column-footer">
          <div class="mr-3">
            {{'footer.customer_service' | translate}}
            <span class="text-primary">{{'footer.branch_1800_8000_number_6' | translate}}</span>
            {{'footer.free' | translate}}
          </div>
          <div>
            {{'footer.email_support' | translate}}
            <span class="text-primary">{{'footer.email_address' | translate}}</span>
          </div>
        </div>
        <span >{{'footer.copy-right' | translate}}</span>
      </div>
    </div>
  </footer>
  <!-- End of Footer -->
</section>
